import script from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"

import "./InfoIcon.vue?vue&type=style&index=0&id=664e3fb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664e3fb4"]])

export default __exports__